export const DOCUMENT_TYPE = {
  DAILY_LOG: "DAILY_LOG",
  FILE: "FILE",
} as const;
